import { SearchOption, searchStateData } from '../../data/searchStateData'
import { useAppSelector } from '../../redux/hooks'
import HowItWorksButton from './howItWorksButton/HowItWorksButton'
import './style.scss'
import SubFilterButton from './subFilterButton/SubFilterButton'
import SubFilterSection from './subFilterSection/SubFilterSection'

function SubFilter() {
	const subFilterSelectionActive = useAppSelector(state => state.search.subFilterSelectionActive)
	const subFilterSelectionIndex = useAppSelector(state => state.search.subFilterSelectionIndex)
	const showHowItWorks = useAppSelector(state => state.search.showHowItWorks)

	return (
		<div className='section-content'>
			<div className="sub-filter-wrap">
				{searchStateData.subFilterOptions.map((option: SearchOption, index: number) => 
					<SubFilterButton 
						searchFilter={option}
						key={`sub-filter-option-${index}`}
						index={index}
					/>
				)}
				<HowItWorksButton />
			</div>
			{subFilterSelectionActive && (
				<SubFilterSection
					searchFilter={searchStateData.subFilterOptions[subFilterSelectionIndex]}
					index={subFilterSelectionIndex}
				/>
			)}
			{showHowItWorks && 
				<div className='sub-filter-section-wrap'>
					<div className="sub-filter-section-label">
						How It Works
					</div>
					<div className='how-it-works-section-wrap'>
						<div className='how-it-works-section'>
							<div className='how-it-works-heading'>
								Step 1
							</div>
							<div className='how-it-works-title'>
								Choose Your Instructor
							</div>
							<div className='how-it-works-text'>
								Begin by selecting your instructor. Use the filters and search bar at the top of the page to narrow down your options based on your preferences. For example, you can specify a group size of one or select instructors by their certification level (e.g., Level 2). If you're not searching by ski school or instructor name, use the advanced filters below to refine your results further-such as language preference, gender, and other instructor attributes.
							</div>
						</div>
						<div className='how-it-works-section'>
							<img
								className='how-it-works-img'
								src='/imgs/how-it-works/how-it-works-1.png'
								alt='how-it-works 1'
							/>
						</div>
					</div>
					<div className='how-it-works-section-wrap'>
						<div className='how-it-works-section'>
							<div className='how-it-works-heading'>
								Step 2
							</div>
							<div className='how-it-works-title'>
								View Instructor Profile
							</div>
							<div className='how-it-works-text'>
								Once you find an instructor that fits your criteria, click on their profile to view more detailed information. The profile includes an overview of the instructor's qualifications, awards, ratings, and experience. If you decide this instructor is right for your analysis, click the "Book Now" button at the top right of their profile. You'll be prompted to confirm the group size (up to three sessions can be booked) and will see the corresponding price for the selected instructor. Click "Book Now" again to proceed to checkout.
							</div>
						</div>
						<div className='how-it-works-section'>
							<img
								className='how-it-works-img'
								src='/imgs/how-it-works/how-it-works-2.png'
								alt='how-it-works 2'
							/>
						</div>
					</div>
					<div className='how-it-works-section-wrap'>
						<div className='how-it-works-section'>
							<div className='how-it-works-heading'>
								Step 3
							</div>
							<div className='how-it-works-title'>
								Upload Your Video and Complete Checkout
							</div>
							<div className='how-it-works-text'>
								On the checkout page, you'll be prompted to upload your video(s)—up to three are allowed—ensuring they meet the quality and duration requirements outlined on the page. You may also include a brief message to the instructor, introducing yourself and highlighting the areas you'd like to improve. If you haven't already, you'll be asked to create an account or log in, as an active profile is required to upload content and receive your analysis. Once this is complete, proceed to the payment section to finalize your booking.
							</div>
						</div>
						<div className='how-it-works-section'>
							<img
								className='how-it-works-img'
								src='/imgs/how-it-works/how-it-works-3.png'
								alt='how-it-works 3'
							/>
						</div>
					</div>
					<div className='how-it-works-section-wrap'>
						<div className='how-it-works-section'>
							<div className='how-it-works-heading'>
								Step 4
							</div>
							<div className='how-it-works-title'>
								Receive Your Analysis
							</div>
							<div className='how-it-works-text'>
								After completing the checkout, you will see a confirmation message in your customer dashboard, and your chosen instructor will be notified of the new request. Your video analysis, feedback and examples of suitable drills will be delivered to your dashboard within 24 hours. You'll receive a notification once the instructor has completed their review.
							</div>
						</div>
						<div className='how-it-works-section'>
							<img
								className='how-it-works-img'
								src='/imgs/how-it-works/how-it-works-4.png'
								alt='how-it-works 4'
							/>
						</div>
					</div>
				</div>
			}
			<div className='how-it-works-mobile'>
				<HowItWorksButton />
			</div>
		</div>
	)
}

export default SubFilter
